<template>
  <div class="motion-safe:animate-pulse motion-reduce:animate-none">
    <span id="teliapay-sr-status-element" class="sr-only" role="status">
      {{ show ? 'Delbetala telefonen räntefritt, läser in Telia Finance' : '' }}
    </span>
    <div v-if="show" class="m-auto h-770 w-[360px]" aria-hidden="true">
      <div class="mt-100">
        <div class="flex flex-row items-end justify-center">
          <div class="w-[120px] h-48 bg-grey-200 rounded-full"></div>
          <div class="w-[88px] h-20 bg-grey-200 rounded-full"></div>
        </div>
        <div class="mt-16 flex flex-row items-end justify-center">
          <div class="w-[120px] h-48 rounded-sm bg-grey-200 mr-16"></div>
          <div class="w-[120px] h-48 rounded-sm bg-grey-200 mr-16"></div>
          <div class="w-[120px] h-48 rounded-sm bg-grey-200 mr-16"></div>
        </div>
        <div class="mt-16 flex flex-col items-center justify-center">
          <div class="w-full h-16 rounded-full bg-grey-200 mb-4"></div>
          <div class="w-full h-16 rounded-full bg-grey-200"></div>
        </div>
        <div class="mt-48 flex flex-col items-center justify-center">
          <div class="w-full h-16 rounded-full bg-grey-200 mb-4"></div>
          <div class="w-full h-16 rounded-full bg-grey-200 mb-4"></div>
          <div class="w-full h-16 rounded-full bg-grey-200"></div>
        </div>
        <div class="mt-16 w-full">
          <div class="h-48 rounded-full bg-grey-200"></div>
        </div>
        <div class="mt-16 w-full">
          <div class="h-200 w-full rounded-sm bg-grey-200"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  show: boolean;
}
defineProps<Props>();
</script>
